import styled, { css } from "styled-components";
import PropTypes from "prop-types";

const TransitionStyle = styled("div", {
  isActive: PropTypes.bool,
})`
  transition: opacity 0.15s linear;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
  
  ${({ isActive }) => !isActive && css`
    opacity: 0;
  `}
`;

export { TransitionStyle };
